<template>
  <div class="main-type-item">
    <h3 class="main-type-item__title">{{ category }}</h3>
    <!-- <div class="main-type-item__amount"><span>{{service_amout}} </span> услуг</div> -->
  </div>
</template>

<script>
export default {
    name: "OneType",
    props: {
        category: String,
        service_amout: Number,
    },
}
</script>
